import type { Prop, PropAttributeTable } from "building-types/props/propTypes";

export function resolvePropAssetId(prop: Prop, propCatalog: PropAttributeTable): number | string {
  const propAttributes = propCatalog[prop.src];
  const assetId = propAttributes.propAssetId;
  return assetId;
}
